import { VDBText } from "@components/atoms";
import {
  convertPriceModeToText,
  priceModeColor,
} from "@components/molecules/PriceModeCard/utils";
import { VDBIcons } from "@utils/VDBIcons";
import { selectedGroupName } from "../searchGroup/utils";

export const generateItem = (
  item: any,
  currentLanguage?: any,
  userInfo?: any,
  theme?: any,
  typography?: any,
  selectedValues?: any,
  selectedGroups?: any,
  otherGroups?: any,
  productTypes?: any,
  isBiometricEnabled?: any,
  biometricType?: any,
  t?: any
) => {
  let newItem: any = {};
  item = {
    ...item,
    leftIconTheme: item.leftIconTheme
      ? theme[item.leftIconTheme]
      : theme["core-04"],
    rightIcon: item.rightIcon || VDBIcons.ARROW_RIGHT,
    rightIconTheme: item.rightIconTheme
      ? theme[item.rightIconTheme]
      : theme["core-04"],
  };
  switch (item.name) {
    case "languages":
      newItem = {
        ...item,
        itemRightText: (
          <VDBText
            type={typography["Body-R"]}
            color={
              item.isSelected ? theme["option-cont-active"] : theme["core-04"]
            }
          >
            {currentLanguage?.title}
          </VDBText>
        ),
      };
      break;
    case "price_mode":
      newItem = {
        ...item,
        itemRightText:
          userInfo.userCanSetMarkupInOrangeMode() &&
          userInfo.isPriceModeLock() ? (
            <VDBText
              type={typography["Body-R"]}
              color={
                item.isSelected ? theme["option-cont-active"] : theme["core-04"]
              }
            >
              {selectedValues.price_markup}
            </VDBText>
          ) : (
            <VDBText
              type={typography["Body-R"]}
              color={
                theme[
                  priceModeColor(
                    selectedValues.price_mode,
                    item.isSelected,
                    theme.isTablet
                  )
                ]
              }
            >
              {t(convertPriceModeToText(selectedValues.price_mode))}
            </VDBText>
          ),
        itemLeftText:
          userInfo.userCanSetMarkupInOrangeMode() && userInfo.isPriceModeLock()
            ? "Price Markup"
            : t(item.label ?? item.itemLeftText),
      };
      break;
    case "jbt_id":
      newItem = selectedValues?.jbt_id
        ? {
            ...item,
            itemRightText: (
              <VDBText
                type={typography["Body-R"]}
                color={
                  item.isSelected
                    ? theme["option-cont-active"]
                    : theme["core-04"]
                }
              >
                {selectedValues.jbt_id}
              </VDBText>
            ),
            itemLeftText: "JBT Number",
            leftIcon: VDBIcons.CHECKMARK,
            leftIconTheme: theme["success-01"],
            rightIcon: "",
            action: null,
            disabled: true,
          }
        : {
            ...item,
            itemRightText: "",
            itemLeftText: item.itemLeftText,
            leftIcon: "",
            leftIconTheme: "",
            rightIcon: VDBIcons.ARROW_RIGHT,
            action: "jbt_connect",
            disabled: false,
          };
      break;
    case "currency":
      newItem = {
        ...item,
        itemRightText: (
          <VDBText
            type={typography["Body-R"]}
            color={
              item.isSelected ? theme["option-cont-active"] : theme["core-04"]
            }
          >
            {userInfo.user?.currency_symbol} {userInfo?.user?.currency}
          </VDBText>
        ),
        itemLeftText: "Currency",
        rightIcon: item.rightIcon || VDBIcons.ARROW_RIGHT,
        rightIconTheme: item.rightIconTheme,
        action: "currency",
        disabled: false,
      };
      break;
    case "biometrics":
      newItem = {
        ...item,
        itemRightText: (
          <VDBText
            type={typography["Body-R"]}
            color={
              item.isSelected ? theme["option-cont-active"] : theme["core-04"]
            }
          >
            {isBiometricEnabled && biometricType === "face" && "Face ID"}
            {isBiometricEnabled &&
              biometricType === "fingerprint" &&
              "Touch ID"}
            {isBiometricEnabled && biometricType === "both" && "Biometric"}
            {!isBiometricEnabled && "Disabled"}
          </VDBText>
        ),
      };
      break;
    case "default_search_group":
      newItem = {
        ...item,
        itemRightText: (
          <VDBText
            type={typography["Body-R"]}
            color={
              item.isSelected ? theme["option-cont-active"] : theme["core-04"]
            }
          >
            {selectedGroupName(selectedGroups, otherGroups, productTypes)}
          </VDBText>
        ),
      };
      break;
    case "logout":
      newItem = {
        ...item,
        itemLeftText: t(item.label ?? item.itemLeftText),
        rightIcon: "",
      };
      break;
    default:
      newItem = {
        ...item,
        itemLeftText: t(item.label ?? item.itemLeftText),
      };
      break;
  }
  return newItem;
};
